export default "__VITE_ASSET__ZDg9cnUT__"